<template>
  <div v-if="isAuthenticated">
    <div class="playlist-tools">
      <div class="playlist-header">
        <feather-icon icon="PlaylistIcon" class="ml-5 playlist-icon-header" :svgClasses="['h-6 w-6 icon-safra icon-primary']" />
        <h4>{{$t('PLAYLIST').Upcoming_Videos}}</h4>
        <vs-button v-if="!listEmpty" class="btn-clear-playlist" type="flat" @click.stop="clearPlaylist()">{{$t('PLAYLIST').Clean}}</vs-button>
        <!-- <feather-icon  v-if="!isDesktop" icon="XIcon" @click.stop="$emit('close')" class="cursor-pointer close-icon-custom"></feather-icon> -->
      </div>
    <!-- <div class="youtube-float-local" v-if="currentMedia"></div> -->
      <!-- <div class="block-button">
        <vs-button v-if="!listEmpty" class="btn-clear-playlist" type="flat" @click.stop="clearPlaylist()">{{$t('PLAYLIST').Clean}}</vs-button>
      </div> -->
      <div class="playlist-list" v-if="isItemList || currentMedia" :class="['scroll-area-v-nav-menu']">
          <!-- <div>
            <playlist-tools-item
              v-if="currentMedia"
              :itemPlaylist="currentMedia"
              :currentMedia="currentMedia"
              @playItem="playMultimedia"
            ></playlist-tools-item>
          </div> -->
        <div v-for="(item, index) in list" :key="index + 1">
              <!-- v-if="canDisplayCurrentItem(item)" -->
          <playlist-tools-item
            :itemPlaylist="item"
            :currentMedia="currentMedia"
            @playItem="playMultimedia"
            ></playlist-tools-item>
          </div>
      </div>
      <!-- <VuePerfectScrollbar
        :settings="settings"
        :suppressScrollX="true"
        class="container-items"
      >
      
        
      </VuePerfectScrollbar> -->
      <!-- <hr>
      <div class="latest-media-list" v-if="latestMedia.length > 0">
        <div class="latest-media-header">
          <h4>Ultimas midias</h4>
        </div>
        <VuePerfectScrollbar
          class="latest-media-scroll"
          :settings="settings"
          :suppressScrollX="true"
        >
          <div v-for="(item, index) in latestMedia" :key="index + 1" style="display: inline-block">
            <playlist-tools-item
              :itemPlaylist="item"
              :currentMedia="currentMedia"
              @playItem="playMultimedia"
            ></playlist-tools-item>
          </div>
        </VuePerfectScrollbar>
      </div> -->
  
      <div class="empty-playlist" v-if="listEmpty && !currentMedia">
        <feather-icon icon="PlaylistIcon" class="ml-5" :svgClasses="['h-12 w-12 icon-safra icon-primary']" />
        <!-- <feather-icon icon="ListIcon" class="ml-5" svg-classes="h-12 w-12" /> -->
        <h3>{{$t('PLAYLIST').Empty_Playlist}}</h3>
        <h6>{{$t('PLAYLIST').Empty_Playlist_Text}}</h6>
      </div>
      <!-- <vs-divider class="mb-0" /> -->
    </div>
    <div v-if="!isDesktop" class="v-nav-menu-swipe-area" v-hammer:swipe.right="onClose"></div>
  </div>
  
  <div v-else>
    <custom-content
      :class="{'mt-5': !isDesktop}"
      :isDesktop="isDesktop"
      @close="close"
      @open-register="$emit('open-register')"
    />
    <div v-if="!isDesktop" class="v-nav-menu-swipe-area" v-hammer:swipe.right="onClose"></div>
  </div>
</template>



<script>
import PlaylistToolsItem from "./PlaylistToolsItem";
import { EventBus } from "../../../../event-bus";
import AppConstants from "../../../../appConstants";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import CustomContent from "../../../../views/pages/CustomContent.vue";

export default {
  props: {
    isDesktop: {
      required: true
    }
  },
  data() {
    return {
      settings: {
          maxScrollbarLength: 60,
          wheelSpeed: 0.3,
          swipeEasing: true
        },
    };
  },
  watch: {
    list(value) {
      // play multimedia when list has only 1 item (first item when playlist is empty)
      // if (value.length == 1) {
      //   if (!this.$store.state.playlistItemSelected) {
      //     this.playMultimedia(value[0]);
      //   }
      // }
     },
     "$store.state.playlistItemSelected"(value) {
      //  if (value) {
      //   this.playMultimedia(value);
      //  }
     }
  },
  computed: {
    contentPrivate() {
      return this.$store.state.contentPrivate || {text: ''};
    },
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
    playlistActive() {
      return this.$store.state.playlistOpen;
    },
    title() {
      return this.currentMedia.content.title.data;
    },
    currentMedia() {
      return this.$store.state.currentMedia;
    },
    list() {
      return this.$store.state.playlist;
    },
    listEmpty() {
      return this.list.length <= 0;
    },
    isItemList() {
      return this.list.length >0;
    },
    featherIconSize() {
      if (this.isDesktop) {
        return "h-8 w-8";
      } else {
        return "h-6 w-6";
      }
    },
    youtubePlayer() {
      return this.$refs.playlistYoutube.player;
    },
    audioPlayer() {
      return this.$refs.playlistAudio.player;
    },
    latestMedia() {
      return this.$store.state.latestMedia;
    }
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    canDisplayCurrentItem(item) {
      if (this.currentMedia) {
        return item._id != this.currentMedia._id;
      }
      return true;
    },
    playMultimedia(item) {
      EventBus.$emit(AppConstants.BUS_EVENT_OPEN_DRAGGABLE_MULTIMEDIA, {
        reportDetail: item,
        isTextSpeech: this.isTextToSpeech(item)
      });
    },
    isTextToSpeech(reportDetail) {
      if (reportDetail.audio || reportDetail.youtubeId || reportDetail.soundcloud || reportDetail.spotify) {
        return false;
      } else if (reportDetail.content.abstract.data || reportDetail.content.body.data) {
        return true;
      }
      return false;
    },
    clearPlaylist() {
      this.$store.dispatch("clearPlaylist", null);
    },
    currentItemEndedPlayNextItem(data) {
      // Remove item on playlist and add a new first item to play
      this.$store.dispatch("removeItemPlaylist", data);
      
      setTimeout(() => {
        console.log('play next');
        console.log(this.list);
        if (!this.listEmpty) {
          this.playMultimedia(this.list[0]);
        }
      }, 1500);
    },
    close() {
      this.$emit('close');
    }
  },
  mounted() {
    // console.log(this.list);
    // console.log(this.listEmpty);

    EventBus.$on(AppConstants.BUS_EVENT_PLAY_NEXT_PLAYLIST, (data) => {
      this.currentItemEndedPlayNextItem(data);
    });
    EventBus.$on(AppConstants.BUS_EVENT_RUN_MEDIA_PLAYLIST, (data) => {
      // this.currentItemEndedPlayNextItem(data);
    });
  },
  beforeDestroy() {
    EventBus.$off(AppConstants.BUS_EVENT_PLAY_NEXT_PLAYLIST);
    EventBus.$off(AppConstants.BUS_EVENT_RUN_MEDIA_PLAYLIST);
  },
  components: {
    PlaylistToolsItem,
    VuePerfectScrollbar,
    CustomContent
  }
};
</script>

<style lang="scss">
.close-icon-custom-content {
  display: flex;
  justify-content: flex-end;
  box-sizing: border-box;
  padding: 10px;
}
.btn-clear-playlist {
  // float: right;
  // color: #f0f0f0!important;
}
.theme-dark .btn-clear-playlist {
  color: #a8cb44 !important;
}
.playlist-list {
  height: 100vh;
  overflow-y: scroll;
}
.playlist-multimedia-content {
  padding: 5px 10px;
}
.empty-playlist {
  text-align: center;
  font-weight: 500;
  font-size: 20px;
  margin-top: 20px;
}
</style>